export { default } from "./isHostComponent.js";